// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ej-6";
export var emphasizeQuantity = "_ej-3";
export var flatBottomCorners = "_ej-5";
export var productImage = "_ej-0";
export var quantityContainer = "_ej-2";
export var tooltip = "_ej-1";
export var wrapAndEllipsesOverflow = "_ej-4";